// extracted by mini-css-extract-plugin
module.exports = {"navText":"sidebar_navText__NIhV8"};